import { createJSONStorage, persist } from 'zustand/middleware'
import { create } from 'zustand'

export interface ChannelSlice {
  isPublic : boolean 
  setIsPublic : (value : boolean) => void
  _hasHydrated : boolean
}

export const useChannel = create(
  persist<ChannelSlice>(
    (set, get) => ({
      isPublic : false,
      _hasHydrated : false,
      setIsPublic : (value : boolean) => {
        set({isPublic : value});
      }
    }),
    {
      name: 'channel-storage-lykstage',
      onRehydrateStorage: () => (state) => {
        if (state) {
          state._hasHydrated = true
        }
      },
      storage: createJSONStorage(() => localStorage),
    }
  )
)
